import { render, staticRenderFns } from "./CurrencyField.vue?vue&type=template&id=6f258ad4&"
import script from "./CurrencyField.vue?vue&type=script&lang=js&"
export * from "./CurrencyField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports